import {updateFactory} from '@modifi/redux'
import {
  PatchPersonRequestView,
  ExistingPersonView,
  getAuthenticatedThemisClient,
} from '@modifi/onboarding-api-clients'
import {NestedError} from '../../../utils'

const apiClient = getAuthenticatedThemisClient()

const {actions} = updateFactory({
  rootSelector: state => state?.modules?.persons?.update,
  actionNamePrefix: 'modules/persons/update',
  // @ts-expect-error returning person view
  submitRequest:
    (a, externalPersonId: string, changes: PatchPersonRequestView) =>
    async (dispatch): Promise<ExistingPersonView> => {
      dispatch(a.pendingAction())
      try {
        let result

        if (Object.keys(changes).length > 0) {
          if (changes.countryCode && ['CN', 'HK', 'AE'].includes(changes.countryCode!)) {
            // eslint-disable-next-line no-param-reassign
            changes.zipCode = '00000'
          }

          result = await apiClient.Person.update({
            externalPersonId,
            body: {
              ...changes,
            },
          }).then(res => res.data())
        } else {
          result = {externalId: externalPersonId}
        }

        dispatch(a.successAction())

        return result
      } catch (error: any) {
        dispatch(a.errorAction(error))
        throw new NestedError(`Error while calling Person.update endpoint`, error)
      }
    },
})

export const {aSubmit: aUpdatePerson} = actions
